var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_menu",
    transform: "translate(-1 -.6)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M2.021.6H17.852a1,1,0,0,1,1.021,1.01h0a1,1,0,0,1-1.021,1.01H2.021C1.511,2.494,1,1.989,1,1.61H1A1,1,0,0,1,2.021.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M7.01,5.8h9.468a1,1,0,0,1,1.01,1.01h0a1,1,0,0,1-1.01,1.01H7.01C6.5,7.694,6,7.189,6,6.81H6A1.086,1.086,0,0,1,7.01,5.8Z",
    transform: "translate(1.512 1.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M4.628,4.277c0-.126-.252-.2-.126-.077h0L1.22,6.977c-.126.126-.126.379,0,.379h0l3.156,2.9c.126.126.126.126.252,0V4.277Z",
    transform: "translate(.033 1.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M2.021,11H17.852a1,1,0,0,1,1.021,1.01h0a1,1,0,0,1-1.021,1.01H2.021C1.511,12.894,1,12.515,1,12.01H1A1.092,1.092,0,0,1,2.021,11Z",
    transform: "translate(0 3.58)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_menu.671b5601a192ba63d53c9cfb4907c06a.svg";